import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Dropdown } from "react-bootstrap";

const DebtorTableRowActionColToggle = React.forwardRef(({ children, onClick }, ref) => (
    <FontAwesomeIcon
        ref={ref}
        className="has-pointer"
        icon="fa-ellipsis"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    />
));

const DebtorTableRowActionCol = ({ setChosenGrouping }) => {
    const menuId = React.useId();
    const toggleId = React.useId();

    return <FontAwesomeIcon
        className="has-pointer"
        icon="fa-ellipsis"
        onClick={(e) => {
            e.preventDefault();
            setChosenGrouping();
        }}
    />;

    return (
        <Dropdown id={menuId} className="caret-off w-100">
            <Dropdown.Toggle as={DebtorTableRowActionColToggle} id={toggleId} />
            <Dropdown.Menu>
                <Dropdown.Item onClick={setChosenGrouping}>
                    View
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );

};

export default DebtorTableRowActionCol;